import fwdLogo from './fwd-logo.png';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Show } from '../index';
import { Link, NavLink } from 'react-router-dom';
import {
  BANK_PORTAL_BANKFEE_LIST,
  BANK_PORTAL_BANKFEE_SCHEDULER_AGB_UPDATE,
  BANK_PORTAL_BANKFEE_SCHEDULER_VCB_UPDATE,
  BANK_PORTAL_CONTEST_LIST,
  BANK_PORTAL_REPORT_FYP,
  BANK_PORTAL_REPORT_FYP_AGB,
  BANK_PORTAL_REPORT_FYP_HDB_DIRECTSALE,
  BANK_PORTAL_REPORT_HDB_POLICY_CANCEL,
  BANK_PORTAL_REPORT_HDB_POLICY_CUSTOMER_INFO,
  BANK_PORTAL_REPORT_HDB_POLICY_FYP_DAILY,
  BANK_PORTAL_REPORT_HDB_POLICY_FYP_MONTHLY,
  BANK_PORTAL_REPORT_HDB_POLICY_ISSUE,
  BANK_PORTAL_REPORT_HDB_POLICY_ISSUE_MONTHLY,
  BANK_PORTAL_REPORT_HDB_POLICY_LAPSE,
  BANK_PORTAL_REPORT_HDB_POLICY_PENDING,
  BANK_PORTAL_REPORT_HDB_POLICY_PROPOSAL,
  BANK_PORTAL_REPORT_HDB_POLICY_REJECT,
  BANK_PORTAL_REPORT_HDB_POLICY_REMIND_PAIDTODATE,
  BANK_PORTAL_REPORT_HDB_POLICY_RENEWAL,
  BANK_PORTAL_REPORT_INFORCED_HDB_DIRECTSALE,
  BANK_PORTAL_REPORT_LEAD_AGB,
  BANK_PORTAL_REPORT_LEAD_TRACKING,
  BANK_PORTAL_REPORT_NAB_FYP,
  BANK_PORTAL_REPORT_NAB_LEAD_TRACKING,
  BANK_PORTAL_REPORT_NAB_POLICY_NEW,
  BANK_PORTAL_REPORT_NAB_RYP,
  BANK_PORTAL_REPORT_POLICY_CLAIM,
  BANK_PORTAL_REPORT_POLICY_CREDITLIFE,
  BANK_PORTAL_REPORT_POLICY_EXPIRED,
  BANK_PORTAL_REPORT_POLICY_INFORCED,
  BANK_PORTAL_REPORT_POLICY_LAPSED,
  BANK_PORTAL_REPORT_POLICY_NEW,
  BANK_PORTAL_REPORT_POLICY_NEW_AGB,
  BANK_PORTAL_REPORT_POLICY_NEW_HDB_DIRECTSALE,
  BANK_PORTAL_REPORT_POLICY_ONLINE,
  BANK_PORTAL_REPORT_RYP,
  BANK_PORTAL_REPORT_RYP_HDB_DIRECTSALE,
  BANK_PORTAL_USER_LIST,
  CORPORATE_LEAD_LIST,
  CREATE_LEAD_URL,
  LEAD_REPORT_URL,
  POLICY_REPORT_URL,
  LOGOUT_URL,
  PROFILE_URL,
  REPORT_URL,
  USER_GUIDE_URL,
  BANK_PORTAL_REPORT_VCB_CUSTOMER_PRIORITY,
  MONTHLY_ISSUED_REPORT_URL,
  BANK_PORTAL_REPORT_VCB_BOTO_SALE_PERFORMANCE,
  BANK_PORTAL_REPORT_VCB_BANKER_SALE_PERFORMANCE,
  BANK_PORTAL_SALE_PERFORMANCE_UPLOAD_LIST,
  BANK_PORTAL_SALE_PERFORMANCE_UPLOAD_CREATE, USER_GUIDE_MC02_URL
} from '../../Routes';
import { CgProfile } from 'react-icons/cg';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

const propTypes = {
  authenticated: PropTypes.bool,
  username: PropTypes.string,
  name: PropTypes.string,
  bank: PropTypes.string,
  isBankStaff: PropTypes.bool,
};

export const Nav = (props) => {
  let {
    username,
    name,
    isBankStaff,
    authenticated,
    bank,
    isHO,
    isBO,
    isTO,
    isBPBankfee,
    isBPContest,
    isBPReport,
    isBPAdmin,
  } = props;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpenHDB, setDropdownOpenHDB] = useState(false);
  const [dropdownOpenAGB, setDropdownOpenAGB] = useState(false);
  const [dropdownOpenHDBDetail, setDropdownOpenHDBDetail] = useState(false);
  const [dropdownOpenBankfeeScheduler, setDropdownOpenBankfeeScheduler] = useState(false);
  const [dropdownOpenNAB, setDropdownOpenNAB] = useState(false);
  const [dropdownOpenContractList, setDropdownOpenContractList] = useState(false);

  const toggle = () => setDropdownOpen(prevState => !prevState);
  const toggleHDB = () => setDropdownOpenHDB(prevState => !prevState);
  const toggleAGB = () => setDropdownOpenAGB(prevState => !prevState);
  const toggleHDBDetail = () => setDropdownOpenHDBDetail(prevState => !prevState);
  const toggleBankfeeScheduler = () => setDropdownOpenBankfeeScheduler(prevState => !prevState);
  const toggleNAB = () => setDropdownOpenNAB(prevState => !prevState);
  const toggleContractList = () => setDropdownOpenContractList(prevState => !prevState);

  const bankPortalDropdownStyle = {
    backgroundColor: 'transparent',
    color: '#e87722',
    border: 'none',
    boxShadow: 'none',
  };
  return (
    <div style={{ minWidth: '700px' }}>
      <div className='navbar navbar-expand-lg navbar-dark bg-dark text-white' style={{ minHeight: '2.25rem' }}>
        <Show if={authenticated}>
          <div className='d-flex justify-content-end mr-4 w-100'>
            <NavLink to={PROFILE_URL}>
              <div className='d-flex align-items-center text-white'>
                <CgProfile className='d-inline mr-1' />
                <span>{[name, username].filter((e) => !!e).join(' - ')}</span>
              </div>
            </NavLink>

            <NavLink to={LOGOUT_URL}>
              <span className='ml-3'>ĐĂNG XUẤT</span>
            </NavLink>
          </div>
        </Show>
      </div>
      <div className='navbar navbar-expand-lg border-top border-bottom d-flex justify-content-between'
           style={{ paddingTop: '0px', paddingBottom: '0px' }}>
        <Link to='/'>
          <div className='my-3'>
            <img src={fwdLogo} alt='fwd-logo' style={{ height: '95px' }} className='ml-4' />
            <Show if={authenticated && (isBankStaff || isHO || isBO || isTO)}>
              <img
                src={`${process.env.PUBLIC_URL}/api/bank-logo`}
                alt='bank-logo'
                style={{ height: '50px', marginLeft: '1rem', paddingLeft: '1rem', borderLeft: '2px solid lightgray' }}
                onError={(i) => (i.target.style.display = 'none')}
              />
            </Show>
          </div>
        </Link>

        <Show if={authenticated}>
          <ul className='navbar-nav mr-3 flex-row'>
            <Show if={bank === 'FWD'}>
              {/* Report */}
              <Show if={isBPReport}>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo<br />VIETCOMBANK
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_NEW} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_CREDITLIFE} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng CreditLife</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_ONLINE} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng Online</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_LEAD_TRACKING} className='nav-link'>
                        <span className='text-uppercase'>Lead Tracking</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_FYP} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm năm nhất đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_RYP} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm tái tục đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_INFORCED} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng bảo hiểm còn hiệu lực</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_EXPIRED} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng bảo hiểm quá hạn</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_LAPSED} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng bảo hiểm hết hiệu lực</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_CLAIM} className='nav-link'>
                        <span className='text-uppercase'>Chi trả quyền lợi bảo hiểm</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_VCB_CUSTOMER_PRIORITY} className='nav-link'>
                        <span className='text-uppercase'>Khách hàng ưu tiên</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_VCB_BOTO_SALE_PERFORMANCE} className='nav-link'>
                        <span className='text-uppercase'>BOTO Sales Performance</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_VCB_BANKER_SALE_PERFORMANCE} className='nav-link'>
                        <span className='text-uppercase'>Banker Sales Performance</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown isOpen={dropdownOpenAGB} toggle={toggleAGB}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo <br />Agribank
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_NEW_AGB} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_FYP_AGB} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm năm nhất đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_LEAD_AGB} className='nav-link'>
                        <span className='text-uppercase'>Lead Tracking</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown isOpen={dropdownOpenHDB} toggle={toggleHDB}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo tổng <br />HDBank
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_NEW_HDB_DIRECTSALE} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_FYP_HDB_DIRECTSALE} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm năm nhất đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_RYP_HDB_DIRECTSALE} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm tái tục đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_INFORCED_HDB_DIRECTSALE} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng bảo hiểm còn hiệu lực</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown isOpen={dropdownOpenHDBDetail} toggle={toggleHDBDetail}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo chi tiết<br />HDBank
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_PROPOSAL} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Hồ sơ yêu cầu bảo hiểm</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_ISSUE} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Hợp đồng bảo hiểm mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_PENDING} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Hợp đồng bảo hiểm chưa giải quyết</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_CANCEL} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Hợp đồng bảo hiểm đã hủy</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_REJECT} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Hồ sơ yêu cầu bảo hiểm đã từ chối</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_FYP_DAILY} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo phí phát sinh trong ngày</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_FYP_MONTHLY} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo phí phát sinh trong tháng</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_ISSUE_MONTHLY} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Hợp đồng phát hành trong tháng</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_CUSTOMER_INFO} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Thông tin khách hàng</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_LAPSE} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Hợp đồng mất hiệu lực</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_RENEWAL} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo Hợp đồng tái tục</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_HDB_POLICY_REMIND_PAIDTODATE} className='nav-link'>
                        <span className='text-uppercase'>Báo cáo nhắc phí Hợp đồng tái tục</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <Dropdown isOpen={dropdownOpenNAB} toggle={toggleNAB}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo<br />NAM A BANK
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_NAB_POLICY_NEW} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_NAB_LEAD_TRACKING} className='nav-link'>
                        <span className='text-uppercase'>Lead Tracking</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_NAB_FYP} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm năm nhất đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_NAB_RYP} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm tái tục đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_VCB_BOTO_SALE_PERFORMANCE} className='nav-link'>
                        <span className='text-uppercase'>BOTO Sales Performance</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_VCB_BANKER_SALE_PERFORMANCE} className='nav-link'>
                        <span className='text-uppercase'>Banker Sales Performance</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Upload Báo cáo
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_SALE_PERFORMANCE_UPLOAD_LIST} className='nav-link'>
                        <span className='text-uppercase'>Danh sách file Upload</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Show>
              {/* Bankfee */}
              <Show if={isBPBankfee}>
                <li className='nav-item'>
                  <NavLink to={BANK_PORTAL_BANKFEE_LIST} className='nav-link'>
                    Hoa hồng
                  </NavLink>
                </li>

                <Dropdown isOpen={dropdownOpenBankfeeScheduler} toggle={toggleBankfeeScheduler}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Đổi ngày chốt <br /> Hoa hồng
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_BANKFEE_SCHEDULER_VCB_UPDATE} className='nav-link'>
                        <span>Vietcombank</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_BANKFEE_SCHEDULER_AGB_UPDATE} className='nav-link'>
                        <span>Agribank</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Show>
              {/* Contest */}
              <Show if={isBPContest}>
                <li className='nav-item'>
                  <NavLink to={BANK_PORTAL_CONTEST_LIST} className='nav-link'>
                    Thi đua
                  </NavLink>
                </li>
              </Show>
            </Show>

            <Show if={bank === 'VCB'}>
              {/* Report */}
              <Show if={isHO || isBO || isTO}>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_NEW} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_CREDITLIFE} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng CreditLife</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_ONLINE} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng Online</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_LEAD_TRACKING} className='nav-link'>
                        <span className='text-uppercase'>Lead Tracking</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_FYP} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm năm nhất đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_RYP} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm tái tục đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_INFORCED} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng bảo hiểm còn hiệu lực</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_EXPIRED} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng bảo hiểm quá hạn</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_LAPSED} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng bảo hiểm hết hiệu lực</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_CLAIM} className='nav-link'>
                        <span className='text-uppercase'>Chi trả quyền lợi bảo hiểm</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_VCB_CUSTOMER_PRIORITY} className='nav-link'>
                        <span className='text-uppercase'>Khách hàng ưu tiên</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_VCB_BOTO_SALE_PERFORMANCE} className='nav-link'>
                        <span className='text-uppercase'>BOTO Sales Performance</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_VCB_BANKER_SALE_PERFORMANCE} className='nav-link'>
                        <span className='text-uppercase'>Banker Sales Performance</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Show>
              {/* Bankfee */}
              <Show if={isHO || isBO || isTO}>
                <li className='nav-item'>
                  <NavLink to={BANK_PORTAL_BANKFEE_LIST} className='nav-link'>
                    Hoa hồng
                  </NavLink>
                </li>
              </Show>
              {/* Contest */}
              <Show if={isHO || isBO || isTO}>
                <li className='nav-item'>
                  <NavLink to={BANK_PORTAL_CONTEST_LIST} className='nav-link'>
                    Thi đua
                  </NavLink>
                </li>
              </Show>
            </Show>
            <Show if={bank === 'HDB'}>
              {/* Report */}
              <Show if={isHO || isBO || isTO}>
                <Dropdown isOpen={dropdownOpenHDB} toggle={toggleHDB}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo tổng
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_NEW_HDB_DIRECTSALE} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_FYP_HDB_DIRECTSALE} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm năm nhất đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_RYP_HDB_DIRECTSALE} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm tái tục đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_INFORCED_HDB_DIRECTSALE} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng bảo hiểm còn hiệu lực</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <Show if={isHO}>
                  <Dropdown isOpen={dropdownOpenHDBDetail} toggle={toggleHDBDetail}>
                    <DropdownToggle caret style={bankPortalDropdownStyle}>
                      Báo cáo chi tiết
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_PROPOSAL} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Hồ sơ yêu cầu bảo hiểm</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_ISSUE} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Hợp đồng bảo hiểm mở mới</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_PENDING} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Hợp đồng bảo hiểm chưa giải quyết</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_CANCEL} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Hợp đồng bảo hiểm đã hủy</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_REJECT} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Hồ sơ yêu cầu bảo hiểm đã từ chối</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_FYP_DAILY} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo phí phát sinh trong ngày</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_FYP_MONTHLY} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo phí phát sinh trong tháng</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_ISSUE_MONTHLY} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Hợp đồng phát hành trong tháng</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_CUSTOMER_INFO} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Thông tin khách hàng</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_LAPSE} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Hợp đồng mất hiệu lực</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_RENEWAL} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo Hợp đồng tái tục</span>
                        </Link>
                      </DropdownItem>
                      <DropdownItem>
                        <Link to={BANK_PORTAL_REPORT_HDB_POLICY_REMIND_PAIDTODATE} className='nav-link'>
                          <span className='text-uppercase'>Báo cáo nhắc phí Hợp đồng tái tục</span>
                        </Link>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </Show>
              </Show>
            </Show>

            <Show if={bank === 'AGR'}>
              {/* Report */}
              <Show if={isHO || isBO || isTO}>
                <Dropdown isOpen={dropdownOpenAGB} toggle={toggleAGB}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_POLICY_NEW_AGB} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_FYP_AGB} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm năm nhất đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_LEAD_AGB} className='nav-link'>
                        <span className='text-uppercase'>Lead Tracking</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Show>
              {/* Bankfee */}
              <Show if={isHO || isBO}>
                <li className='nav-item'>
                  <NavLink to={BANK_PORTAL_BANKFEE_LIST} className='nav-link'>
                    Hoa hồng
                  </NavLink>
                </li>
              </Show>
              {/* Contest
              <Show if={isHO || isBO}>
                <li className='nav-item'>
                  <NavLink to={BANK_PORTAL_CONTEST_LIST} className='nav-link'>
                    Thi đua
                  </NavLink>
                </li>
              </Show>
               */}
            </Show>
            <Show if={bank === 'NAB'}>
              {/* Report */}
              <Show if={isHO || isBO || isTO}>
                <Dropdown isOpen={dropdownOpenNAB} toggle={toggleNAB}>
                  <DropdownToggle caret style={bankPortalDropdownStyle}>
                    Báo cáo<br />NAM A BANK
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_NAB_POLICY_NEW} className='nav-link'>
                        <span className='text-uppercase'>Hợp đồng mở mới</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_NAB_LEAD_TRACKING} className='nav-link'>
                        <span className='text-uppercase'>Lead Tracking</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_NAB_FYP} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm năm nhất đã thu</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem>
                      <Link to={BANK_PORTAL_REPORT_NAB_RYP} className='nav-link'>
                        <span className='text-uppercase'>Phí bảo hiểm tái tục đã thu</span>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Show>

            </Show>
            {/* User management */}
            <Show if={isBPAdmin}>
              <li className='nav-item'>
                <NavLink to={BANK_PORTAL_USER_LIST} className='nav-link'>
                  Quản lý tài khoản<br /> Bank Portal
                </NavLink>
              </li>
            </Show>
            <Show if={isBankStaff && ['VCB', 'AGR', 'ABB', 'NAB'].includes(bank)}>
              <li className='nav-item'>
                <NavLink to={CORPORATE_LEAD_LIST} className='nav-link'>
                  Khách hàng <br /> doanh nghiệp
                </NavLink>
              </li>
            </Show>
            <Show if={isBankStaff && ['VCB', 'AGR', 'ABB', 'NAB'].includes(bank)}>
              <li className='nav-item'>
                <NavLink to={CREATE_LEAD_URL} className='nav-link'>
                  Khách hàng <br /> cá nhân
                </NavLink>
              </li>
            </Show>
            <Show if={(isBankStaff || isBO || isTO) && ['VCB', 'AGR', 'ABB', 'NAB'].includes(bank)}>
              <li className='nav-item'>
                <Link to={LEAD_REPORT_URL} className='nav-link'>
                  DANH SÁCH <br /> KHÁCH HÀNG
                </Link>
              </li>
            </Show>
            <Show if={(isBankStaff || isHO || isBO || isTO) && ['VCB', 'AGR', 'ABB', 'NAB'].includes(bank)}>
              {/* <li className='nav-item'>
                <Link to={POLICY_REPORT_URL} className='nav-link'>
                  DANH SÁCH <br /> HỢP ĐỒNG
                </Link>
              </li> */}
              <Dropdown isOpen={dropdownOpenContractList} toggle={toggleContractList}>
                <DropdownToggle caret style={bankPortalDropdownStyle}>
                  DANH SÁCH <br /> HỢP ĐỒNG
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <Link to={POLICY_REPORT_URL} className='nav-link'>
                      DANH SÁCH HĐ ĐẾN HẠN THU PHÍ
                    </Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link to={MONTHLY_ISSUED_REPORT_URL} className='nav-link'>
                      DANH SÁCH HĐ BH DOANH NGHIỆP <br/> PHÁT HÀNH TRONG THÁNG
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Show>
            <Show if={isBankStaff && ['VCB', 'AGR', 'ABB', 'NAB'].includes(bank)}>
              <li className='nav-item'>
                <Link to={REPORT_URL} className='nav-link'>
                  BÁO CÁO
                </Link>
              </li>
            </Show>

            <Show if={isBankStaff && bank === 'VCB'}>
              <li className='nav-item'>
                <NavLink to={BANK_PORTAL_CONTEST_LIST} className='nav-link'>
                  Thi đua
                </NavLink>
              </li>
              <li className='nav-item'>
                <Link to={USER_GUIDE_URL} className='nav-link'>
                  HƯỚNG DẪN <br /> SỬ DỤNG
                </Link>
              </li>
            </Show>

            <Show if={isBankStaff && bank === 'VCB'}>
              <li className='nav-item'>
                <Link to={USER_GUIDE_MC02_URL} className='nav-link'>
                  TÀI LIỆU <br />ĐÀO TẠO MC02
                </Link>
              </li>
            </Show>
          </ul>
        </Show>
      </div>
    </div>
  );
};

Nav.propTypes = propTypes;

export default Nav;
